import { useModalStack } from "@inertiaui/modal-react";
import { progress } from "@inertiajs/react";
import { useShowFlash } from "@sprout/flash.tsx";
import useTranslation from "@hooks/use_translation.ts";

let opening = false;

const useInertiaModal = () => {
  const { visitModal } = useModalStack();
  const showFlash = useShowFlash();
  const { t } = useTranslation("misc");

  const onError = () => showFlash(t("defaultError"), "error");

  const openModal = (path: string) => {
    if (opening) return;

    opening = true;
    progress.reveal(true);
    void visitModal(path)
      .catch(onError)
      .finally(() => {
        opening = false;
      });
  };

  return { openModal, onError };
};

export default useInertiaModal;
